export const SITE_DEFAULT_COLS = ['df_short_name', 'ns_name', 'matched', 'punches'];
export const LM_DEFAULT_COLS   = ['lm_name', 'lm_labor_metrics_type_xref_code', 'lm_ledger_code', 'punches', 'sites_used'];
export const CC_DEFAULT_COLS   = ['dept_name', 'cc_no', 'dept_is_active', 'labor_metrics_count', 'map_419_count', 'locations_count'];
export const TM_DEFAULT_COLS   = ['lm_name', 'lm_ledger_code', 'loc_site_code', 'loc_name', 'dept_name', 'has_ns_mapping', 'punches'];

export const FROZEN_COLS = [
  { key: 'excl_st',   label: 'Excl ST' },
  { key: 'excl_ot',   label: 'Excl OT' },
  { key: 'excl_hol',  label: 'Excl HOL' },
  { key: 'excl_vac',  label: 'Excl VAC' },
  { key: 'excl_prem', label: 'Excl PREM' },
];

// Color palettes used by ColumnPicker + table-header eyebrows.
export const GROUP_COLORS = {
  Dayforce:        '#002159',
  NetSuite:        '#e65100',
  Activity:        '#4a148c',
  'Labor Metrics': '#1b5e20',
  'Cost Centers':  '#795548',
  Derived:         '#795548',
  Rules:           '#795548',
};

export const HEADER_COLORS = {
  Dayforce:        '#90caf9',
  NetSuite:        '#ffcc80',
  Activity:        '#e1bee7',
  'Labor Metrics': '#c8e6c9',
  'Cost Centers':  '#d7ccc8',
  Derived:         '#d7ccc8',
  Rules:           '#d7ccc8',
};
